import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) { }

  login(data: any) {
    const url = `${environment.serverUrl}/auth/login`;
    return this.http.post(url, data).pipe(tap((result: any) => { }));
  }

  autoLogin(data: any) {
    const url = `${environment.serverUrl}/auth/auto-login`;
    return this.http.post(url, data).pipe(tap((result: any) => { }));
  }

  logout(data: any) {
    const url = `${environment.serverUrl}/auth/logout`;
    return this.http.post(url, data).pipe(tap((result: any) => { }));
  }

  public mslLogin(token: string, loginCurrentSystem?: boolean) {
    let data = { auth_code: token, loginCurrentSystem: loginCurrentSystem };
    const url = `${environment.serverUrl}/auth/msal-login`;
    return this.http.post(url, data).pipe(tap((result: any) => { }));
  }

  public fetchScreenAccessData() {
    const url = `${environment.serverUrl}/auth/screen-access`;
    return this.http.get(url);
  }
}
